require('./jquery.js');
require("./bootstrap.js");

import * as ace from "ace-builds";
import 'ace-builds/src-noconflict/theme-tomorrow.js';

const { PaintTool } = require("./paint.js");
window.PaintTool = PaintTool;

const { RichEditor } = require("./richeditor.js");
window.RichEditor = RichEditor;